const ADMIN_GROUPS = ['admin', 'manager'];
const ADMIN_LEADS_PATH = '/app/admin/leads';
const ADMIN_USERS_PATH = '/app/admin/users';
const API_BASE_URL = '/api/clients-dmp/v1';
const AUTH_LOGIN_ENDPOINT_PATH = `${API_BASE_URL}/auth/login`;
const AUTH_LOGOUT_ENDPOINT_PATH = `${API_BASE_URL}/auth/logout`;
const LOGOUT_PATH = '/app/logout';
const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

const deriveIsAdmin = (user) => (user?.groups ?? []).some((group) => ADMIN_GROUPS.includes(group));

const getAuthLoginEndpointUrl = () => AUTH_LOGIN_ENDPOINT_PATH;

export {
    ADMIN_GROUPS,
    ADMIN_LEADS_PATH,
    ADMIN_USERS_PATH,
    API_BASE_URL,
    AUTH_LOGIN_ENDPOINT_PATH,
    AUTH_LOGOUT_ENDPOINT_PATH,
    deriveIsAdmin,
    getAuthLoginEndpointUrl,
    LOGOUT_PATH,
    REDIRECT_AFTER_LOGIN_KEY,
};
